import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import actions from "../../../Store/actions";
import styles from "./styles";
import {
    Box,
    TextField,
    MenuItem,
    FormControlLabel,
    Checkbox,
} from "@mui/material/";
import DatePicker from "../DatePicker/index.js";
import useAssetJourneyHelpers from "../useAssetJourneyHelpers";
import { enums } from "../../../common/lib";
import config from "../../../config";

const ExcludeAsset = ({ actionBtnUpdate, assetMode = "exclude" }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { baseUrl } = config.api;
    const isCheckVentory = baseUrl.includes("checkventory");

    const {
        isDateRequired,
        showExclusionDatePicker,
        setShowExclusionDatePicker,
        setIsDateRequired,
        disableDatePicker,
        setDisableDatePicker,
    } = useAssetJourneyHelpers(actionBtnUpdate, assetMode);

    const { assetDetails, typesList } = useSelector((state) => state);

    const { exclusionReasonTypeId, exclusionReasonDate } = assetDetails;

    const exclusionReasonTypes = typesList.exclusionReasonTypes.data;

    /** Is exclusion datepicker required
     * We have to use ids instead of the name
     */
    const { assetDeliveredToCustomerAndNotPaid, assetIsSold } =
        enums.exclusionReason;
    const isExclusionDate = [assetIsSold, assetDeliveredToCustomerAndNotPaid];

    const isDatePickerExclusion = (id) => isExclusionDate.includes(id);
    useEffect(() => {
        if (exclusionReasonTypeId)
            setShowExclusionDatePicker(
                isExclusionDate.includes(exclusionReasonTypeId)
            );
    }, [isExclusionDate]);

    const onExclusionReasonChange = (evt) => {
        const { value } = evt.target;

        const isExclusionDatePicker = isDatePickerExclusion(value);
        setShowExclusionDatePicker(isExclusionDatePicker);
        setDisableDatePicker(false);
        setIsDateRequired(false);
        dispatch(
            actions.assetDetails.create.set({
                exclusionReasonTypeId: value,
                exclusionReasonDate:
                    isExclusionDatePicker && !disableDatePicker
                        ? exclusionReasonDate
                        : null,
            })
        );
    };

    const onDisableDateCheckboxChange = (event) => {
        setIsDateRequired(event.target.checked);
        setDisableDatePicker(event.target.checked);
        dispatch(
            actions.assetDetails.create.set({ exclusionReasonDate: null })
        );
    };

    return (
        <>
            <Box sx={styles.exclusionReason}>
                <TextField
                    id="exclusion-reason-select"
                    value={exclusionReasonTypeId}
                    label={t("exclusionReason")}
                    onChange={onExclusionReasonChange}
                    fullWidth
                    select
                >
                    <MenuItem value={0} name={"none"}>
                        <em>{t("none")}</em>
                    </MenuItem>
                    {exclusionReasonTypes.map((item, index) => (
                        <MenuItem value={item.id} key={index}>
                            {item.name}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>

            {showExclusionDatePicker && (
                <>
                    <DatePicker
                        disableDatePicker={disableDatePicker}
                        isFutureDisabled={
                            exclusionReasonTypeId === assetIsSold ? true : false
                        }
                        datepickerLabel={
                            exclusionReasonTypeId === assetIsSold
                                ? t("soldDate")
                                : t("dateOfPayment")
                        }
                    />
                    {exclusionReasonTypeId ===
                        assetDeliveredToCustomerAndNotPaid && (
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isDateRequired}
                                    onChange={onDisableDateCheckboxChange}
                                />
                            }
                            label={t("messages.dateUnavailable")}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default ExcludeAsset;

{
    /* TODO
 1. For stellantis the code is added from enum. This is to be removed when we get codes from backend
 */
}
